import React from 'react';

import { Group, RadioChoice, Toggle } from './OptionControls';

const HORIZONS = [3, 6, 12];

/**
 * The cashflow section's options: how far the chart's forecast reaches,
 * whether the period table breaks down by department and, when the project
 * has VAT/GST or tax lines, whether VAT/GST is included.
 */
const CashflowOptions = ({ options, cashflowTaxAvailable, readOnly, onChange }) => {
    const set = (changes) => onChange({ ...options, ...changes });

    return (
        <div className="tw-flex tw-flex-col tw-mt-3 tw-ps-4 tw-border-s-2 tw-border-charcoal-15">
            <Group title={$t('Forecast horizon')}>
                <RadioChoice
                    name="mp-cashflow-horizon"
                    label={$t('Forecast horizon')}
                    value={options.horizon}
                    choices={HORIZONS.map((months) => ({ value: months, label: $t('{{count}} months', { count: months }) }))}
                    disabled={readOnly}
                    onChange={(horizon) => set({ horizon })}
                />
            </Group>

            <Group title={$t('Period table')}>
                <Toggle
                    label={$t('Group by department')}
                    hint={$t('Breaks inflows and outflows down by department, with subtotals.')}
                    checked={!!options.group_by_department}
                    disabled={readOnly}
                    onChange={() => set({ group_by_department: !options.group_by_department })}
                />
            </Group>

            {cashflowTaxAvailable && (
                <Group title={$t('VAT/GST')}>
                    <Toggle
                        label={$t('Include VAT/GST')}
                        hint={$t('When off, VAT/GST lines are hidden and net figures exclude tax.')}
                        checked={!!options.include_vat}
                        disabled={readOnly}
                        onChange={() => set({ include_vat: !options.include_vat })}
                    />
                </Group>
            )}
        </div>
    );
};

export default CashflowOptions;
